const getUploadProgress = ({ progressEvent, uploadStartDate })=>{
    const { loaded, total } = progressEvent;
    const progress = Math.round(loaded / total * 100);
    const timeElapsed = new Date().getTime() - uploadStartDate.getTime();
    const uploadSpeed = loaded / (timeElapsed / 1000);
    const remainingSeconds = (total - loaded) / uploadSpeed;
    return {
        progress: progress >= 100 ? 99 : progress,
        uploadSpeed,
        remainingSeconds: isFinite(remainingSeconds) ? remainingSeconds : 0
    };
};
const src_getUploadProgress = getUploadProgress;
export default src_getUploadProgress;
